export enum CookiesNameType {
  /*uses index.html*/
  ANALYTICAL_COOKIES = 'analytical_cookies',
  PERSONALIZED_ADS = 'personalized_ads',
}
